import { Button } from '@mantine/core';
import { IconPlug } from '@tabler/icons-react';

type Props = {
  isEnabled: boolean;
  title: string;
  onClick: () => void;
  isLoading: boolean;
};

export const EnableButton = ({ isEnabled, title, onClick, isLoading }: Props) => {
  return (
    <Button
      justify="space-between"
      loading={isLoading}
      leftSection={<IconPlug size={16} />}
      variant={isEnabled ? 'light' : 'default'}
      color="teal"
      size="compact-xs"
      radius="md"
      onClick={onClick}
    >
      {title}
    </Button>
  );
};
